export function base64ToPdfBlob(base64Data: string): Blob {
  // Decode base64 to byte array
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // Create PDF blob
  return new Blob([byteArray], { type: "application/pdf" });
}

export function downloadBlob(blob: Blob, fileName: string): void {
  // Create object URL and download link
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;

  // Append to body, trigger download, then clean up
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

/**
 * Helper function to convert a file to a string
 */
export const fileToString = (file: File) => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    // Event listener for successfully reading the file
    reader.onload = () => resolve(reader.result);

    // Event listener for errors
    reader.onerror = () => reject(reader.error);

    // Read the file as a text string
    reader.readAsText(file);
  });
};
